<template lang="pug">
.header.bar(:class="{ searchFocus, shown, flexy: !doco }")
  .logo(:class="{ twoFilters, engage }")
  .links.cheatsheet
    //a {{ pdfView && 'Viewer' || 'Cheat Sheet' }}
    a(v-if="hasCheatsheetPages && (!groupBy || editing)", @click="scrollToUpper") Pages
    a(v-if="playlist && playlist.length && !engage", @click="scrollTo('.video-section')") Videos
    a(v-if="hasInsightDocs && (!groupBy || editing) || pdfView", @click="scrollToLower") {{ cloud && 'Topics' || hasInsightDocs && (!groupBy || editing) && !pdfView && 'Insights' || 'Viewer' }}
    a(v-if="loadedDocuments && loadedDocuments.length", @click="scrollTo('.document-section')") Documents
    a(v-if="loadedTweets && loadedTweets.length", @click="scrollTo('.tweet-section')") Tweets
    a(v-if="loadedFeeds && loadedFeeds.length", @click="scrollTo('.feed-section')") Feeds
  .title(:title="title || 'loading...'",
         :class="{ cheatsheet: cheatsheetLP, searchFocus, oneFilter, twoFilters, framed }")
    label(v-if="cheatsheetLP && editing")
      input(v-model="loadedTitle", :placeholder="title")
    .not-edit(v-else, @click.alt.stop.prevent="toggleChart", @dblclick.stop.prevent="toggleChart") {{ loadedTitle || title || 'loading...' }}
      span.favorite(:title="`${ isFavorite && 'remove' || 'add' } ${ isFavorite && 'from' || 'to' } favorites`",
                    :class="{ hide: authStatusLabel !== 'auth' }")
        svg(:class="{ on: isFavorite }",
            @click="toggleFavorite",
            xmlns="http://www.w3.org/2000/svg",
            width="64.000000pt",
            height="64.000000pt",
            viewBox="0 0 64.000000 64.000000",
            preserveAspectRatio="xMidYMid meet")
          g(transform="translate(0.000000,64.000000) scale(0.100000,-0.100000)")
            path(d="M121 514 c-42 -35 -56 -87 -41 -144 9 -37 29 -62 104 -135 50 -50 100 -101 109 -115 18 -24 18 -25 29 -5 6 11 55 63 109 115 110 107 131 150 110 221 -26 86 -133 119 -200 63 l-31 -26 -31 26 c-43 36 -115 37 -158 0z")

  //-.toolbar
    .button.charts
  .lp(v-if="cheatsheetLP") {{ cheatsheetLP }}
  //-reading-list
  .spotlight-source(v-if="spotlightInfo",
                    v-lazy:background-image="spotlightInfo.i",
                    @click="spotlightSource = !spotlightSource && 'weaveai' || null",
                    :title="spotlightSource && `limit sources to ${ spotlightInfo.n }` || 'use all sources'",
                    :class="{ on: !spotlightSource }")
  .launch-tour(@click="tourShown = !tourShown") tour
  .profile(:class="{ shown: showProfile }")
    .title {{ authStatusLabel === 'auth' && 'logged' || (!authStatusLabel || authStatusLabel === 'shown') && 'log' || 'logging' }} in
    .code(:class="{ hide: authStatusLabel === 'auth' }")
      qr-code(:value="`https://auth.weave.ai/${ authLp };mod=1`")
    .log-out(:class="{ hide: authStatusLabel !== 'auth' }", @click="logOut") log out
    .auth-status(:class="{ initial: authStatusLabel === 'shown', complete: authStatusLabel === 'auth' }")
      .box(v-for="state in authStatuses", :class="{ [state]: true, on: statusOn(state) }")
  .mask
  .mini-profile(:class="{ known: authStatusLabel === 'auth' }", @click="showProfile = !showProfile")
    .title(:class="{ hide: showProfile }") {{ authStatusLabel === 'auth' && 'logged' || 'log' }} in
    svg(xmlns="http://www.w3.org/2000/svg", width="300.000000pt", height="292.040816pt", viewBox="0 0 300.000000 292.040816", preserveAspectRatio="xMidYMid meet")
      g(transform="translate(0.000000,292.040816) scale(0.030612,-0.030612)", stroke="none")
        path(d="M4790 9534 c-674 -50 -1299 -398 -1730 -964 -333 -438 -526 -928 -602 -1525 -19 -152 -16 -580 6 -740 68 -504 227 -940 480 -1319 355 -531 846 -898 1405 -1052 366 -100 796 -100 1162 0 835 229 1517 948 1783 1880 87 302 119 543 119 881 0 342 -35 596 -122 897 -304 1039 -1099 1784 -2051 1922 -109 16 -355 27 -450 20z")
        path(d="M3050 3219 c-931 -165 -1719 -389 -2088 -596 -227 -127 -394 -379 -561 -843 -143 -401 -285 -1005 -376 -1602 -14 -92 -25 -169 -25 -172 0 -3 2205 -6 4901 -6 l4901 0 -6 48 c-67 546 -124 864 -221 1237 -141 543 -320 936 -530 1163 -140 151 -381 275 -795 410 -402 131 -1032 279 -1565 367 l-160 26 -218 -215 c-534 -527 -970 -866 -1247 -967 -159 -58 -242 -49 -435 45 -283 139 -643 426 -1116 893 -190 188 -251 243 -270 242 -13 0 -98 -14 -189 -30z")
  .notifications-section(v-if="engage && engage.notifications",
                         :class="{ hot, very: wiggle, open: engageNotificationsShown }")
    .count(@click="engageNotificationsShown = !engageNotificationsShown") {{ engage.notifications.all.count }}
    .label(@click="engageNotificationsShown = !engageNotificationsShown") {{ engage.notifications.all.label }}
    .notifications-wrap
      .close(@click="engageNotificationsShown = false") &times;
      .items
        .videos(:class="{ hide: !engage.notifications.pubVideos.ids.length }")
          .video(v-for="(section, id) in engage.notifications.pubVideos.itemToSubsectionIds",
                 @click="playVid(id)")
            .bg(v-lazy:background-image="`https://i.ytimg.com/vi/${ id }/mqdefault.jpg`")
            .details
              .title {{ engage.videos[id].t }}
              .age {{ new Date(engage.videos[id].pa) | moment('from', 'now') }}
        .documents(:class="{ hide: !engage.notifications.documents.ids.length }")
          .document(v-for="(sections, id) in engage.notifications.documents.itemToSubsectionIds",
                    @click="openDocumentSection(sections, id)",
                    :title="engage.docs[id].title")
            .bg(v-lazy:background-image="`https://d2ks69eyvb68ub.cloudfront.net/api/GetDocProcPdfThumbnail?did=${ id }&page=${ 1 }`")
            .details
              .age {{ new Date(engage.docs[id].pubDate) | moment('from', 'now') }}
  .engage-links(v-if="engageBap", @click="engageLinksShown = !engageLinksShown", :class="{ on: engageLinksShown }")
    span links
  .engage-bap(v-if="engageBap")
    .play-button(@click="playBap")
      .play-pause(:class="{ paused: engagePlaying }")
    .report-card-opener(v-if="engageBap.reportCard", @click="engageReportCardShown = true") report card
    .pub-logo(:style="{ 'background-image': `url('https://content.weave.ai/picture-images/${ engageBap.id.toLowerCase() }-logo.jpg')` }")
</template>
<script>
// import readingList from './reading-list';
import { mapGetters, mapActions } from 'vuex';
import { vuexComputed, licensePlate } from '@/helpers';
import qrCode from '@/components/qr';
// import reportOpener from '@/components/report-opener';
export default {
  name: 'headr',
  props: {
    toggleVideos: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return { wiggle: false, stopAllWiggling: false };
  },
  watch: {
    very(newValue) {
      if (newValue) {
        this.startWiggle();
      }
    },
    engageNotificationsShown(newValue) {
      if (newValue) {
        this.stopAllWiggling = true;
      }
    }
  },
  computed: {
    ...mapGetters([
      'selectedToggler',
      'framed',
      'cheatsheetLP',
      'editing',
      'playlist',
      'loadedDocuments',
      'loadedTweets',
      'loadedFeeds',
      'editing',
      'groupBy',
      'analytics',
      'engage',
      'engageBap',
      'engagePlaylist',
      'engagePlaying',
      'engageSelectedDocuments',
      'authStatuses',
      'authStatusLabel',
      'authLp'
    ]),
    ...mapGetters('insightsNS', ['hasCheatsheet']),
    ...vuexComputed(
      'query',
      'shown',
      'cloud',
      'pdfView',
      'videosShown',
      'tweetsShown',
      'documentsShown',
      'selected',
      'selectedTags',
      'selectedTagsLength',
      'searchFocus',
      'title',
      'collapse',
      'doco',
      'loadedTitle',
      'chartShown',
      'playlist',
      'currentVideo',
      'player',
      'playing',
      'collapsed',
      'engageReportCardShown',
      'engageLinksShown',
      'engageNotificationsShown',
      'engageSelectedSection',
      'showProfile',
      'tourShown',
      'authStatus',
      'au',
      'spotlightSource'
    ),
    spotlightInfo() {
      return Object.values(this.engage.spotlightInfo.sourcesTable || {}).find(({ id }) => id !== 'weaveai');
    },
    isFavorite() {
      return this.au?.fr?.includes('w');
    },
    notifications() {
      const { engage } = this;
      return engage?.notifications;
    },
    notificationsAge() {
      const timestamp = this.engage?.notifications.all.timestamp;
      return timestamp && (new Date() - new Date(timestamp)) / 1000 / 60 / 60 / 24;
    },
    hot() {
      const { notificationsAge = 100 } = this;
      // return notificationsAge <= 7;
      return notificationsAge <= 17;
    },
    very() {
      const { notificationsAge = 100 } = this;
      // return notificationsAge <= 2;
      return notificationsAge <= 16;
    },
    twoFilters() {
      return this.selectedTagsLength > 1;
    },
    oneFilter() {
      return this.selectedTagsLength === 1;
    },
    hasCheatsheetPages() {
      return !!Object.keys(this.$store.getters.loadedPages || {}).length;
    },
    hasInsightDocs() {
      return !!Object.keys(this.$store.getters['insightsNS/cheatsheet']?.documents || {}).length;
    }
  },
  methods: {
    ...mapActions(['toggleEngageSelectedDocument', 'engageNotificationClicked', 'toggleFavorite']),
    async logOut() {
      await (this.au = null);
      await (this.authStatus = '');
      location.reload();
    },
    startWiggle() {
      // console.log('very is true');
      const wiggle = () => {
        // console.log('wiggle');
        this.wiggle = true;
        setTimeout(() => {
          // console.log('stop wiggle');
          this.wiggle = false;
          setTimeout(() => {
            if (!this.stopAllWiggling) {
              wiggle();
            }
          }, 20 * 1000);
        }, 6 * 1000);
      };
      wiggle();
    },
    statusOn(status) {
      const { authStatusLabel, authStatuses } = this;
      const statuses = Object.values(authStatuses);
      return status === authStatusLabel || statuses.indexOf(status) < statuses.indexOf(authStatusLabel);
    },
    playBap() {
      const { engagePlaying: playing, currentVideo, engagePlaylist, player } = this;
      if (playing) {
        player?.pauseVideo();
      } else {
        if (currentVideo) {
          player?.playVideo();
        } else {
          this.collapsed = false;
          this.currentVideo = engagePlaylist[0];
          this.playlist = engagePlaylist;
        }
      }
    },
    playVid(id) {
      const { engagePlaying: playing, currentVideo, engagePlaylist, player, engageNotificationClicked } = this;
      engageNotificationClicked(['video', id]);
      // console.log('playVid', id, playing);
      // todo: playing is not working here (always false)
      if (playing && currentVideo?.id === id) {
        player?.pauseVideo();
      } else {
        // if (currentVideo) {
        //   player?.playVideo();
        // } else {
        if (!currentVideo) {
          this.collapsed = false;
        }
        this.currentVideo = engagePlaylist.find(vid => vid.id === id) || null;
        this.playlist = engagePlaylist;
        // }
      }
    },
    async openDocumentSection(sections, id) {
      const { engage, toggleEngageSelectedDocument, engageSelectedDocuments, engageNotificationClicked } = this;
      console.log('openDocumentSection', engage?.sections, sections[0]);
      const selectedSection = engage?.sections.find(({ subsections }) =>
        subsections.find(subsection => subsection.id === sections[0])
      ).title;
      engageNotificationClicked([selectedSection, id]);
      await (this.engageSelectedSection = selectedSection);
      if (!engageSelectedDocuments[id]) {
        toggleEngageSelectedDocument(id);
      }
    },
    toggleChart() {
      this.chartShown = !this.chartShown;
    },
    scrollToLower() {
      console.log('scrollToLower');
      // window.scrollBy(0, document.querySelectorAll('.headers')[1].getBoundingClientRect().top - 40);
      window.scrollBy({
        behavior: 'smooth',
        top: document.querySelectorAll('.analysis .headers')[0].getBoundingClientRect().top - 40
      });
    },
    scrollToUpper() {
      window.scrollTo({ behavior: 'smooth', top: 0 });
    },
    scrollTo(selector) {
      const section = document.querySelector(selector);
      //console.log('scrollTo', selector, section);
      if (section) {
        window.scrollBy({ behavior: 'smooth', top: section.getBoundingClientRect().top - 40 });
      }
    }
  },
  // components: { qrCode, reportOpener },
  components: { qrCode },
  mounted() {
    const { very, startWiggle } = this;
    if (very) {
      startWiggle();
    }
  }
};
</script>
<style scoped lang="scss">
@import '../../scss/global';
$brn: #8d6e4f;
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: 20;
  transform: translate3d(0, 0, 0);
  @include large {
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    padding: 0.35rem 0;
    background-color: white;
    box-shadow: 0 1px 3px #777;
    padding-right: 12.375rem;
  }
  .toolbar {
    display: grid;
    grid-template-columns: auto;
    padding-top: 0.8rem;
    .button {
      width: 2rem;
      height: 2rem;
      background: white no-repeat center;
      background-size: contain;
      &.charts {
        background-image: url("data:image/svg+xml;charset%3Dutf8,%3Csvg xmlns%3D'http://www.w3.org/2000/svg' width%3D'48' height%3D'48' viewBox%3D'0 0 48 48'%3E%3Cpath fill%3D'%238d6e4f' d%3D'M38 6h-28c-2.21 0-4 1.79-4 4v28c0 2.21 1.79 4 4 4h28c2.21 0 4-1.79 4-4v-28c0-2.21-1.79-4-4-4zm-20 28h-4v-14h4v14zm8 0h-4v-20h4v20zm8 0h-4v-8h4v8z'/%3E%3Cpath d%3D'M0 0h48v48h-48z' fill%3D'none'/%3E%3C/svg%3E")
      }
    }
  }
  .links {
    //width: 10rem;
    // position: absolute;
    // left: 9rem;
    //margin-left: -20rem;
    //margin-right: -20rem;
    padding-top: 0.75rem;
    display: flex;
    a {
      cursor: pointer;
      display: inline-block;
      padding: 0.5rem;
      color: $brn;
      white-space: nowrap;
    }
  }
  .logo {
    cursor: pointer;
    margin: 0.35rem;
    background-color: white;
    width: 55px;
    height: 55px;
    border-radius: 50%;
    position: relative;
    //border: 1px solid $brn;
    @include large {
      margin: 0 0.35rem;
      border-color: transparent;
    }
    @include small {
      &.twoFilters {
        opacity: 0;
      }
    }
    &::before {
      content: '\00a0';
      display: inline-block;
      border: none;
      width: 55px;
      height: 40px;
      position: relative;
      background: no-repeat center top
        url("data:image/svg+xml;charset%3Dutf8,%3Csvg xmlns%3D'http://www.w3.org/2000/svg' viewBox%3D'0 0 208 208' version%3D'1.2'%3E%3Ccircle cx%3D'104' cy%3D'104' r%3D'104' fill%3D'%23e1e1e1'/%3E%3Ccircle cx%3D'104' cy%3D'104' r%3D'92.34' stroke%3D'%238d6e4f' stroke-width%3D'5' fill%3D'%238d6e4f'/%3E%3Cpath d%3D'M83.19,149.46c1.67,4.73-1.06,8.6-6.07,8.6H63.43a13.88,13.88,0,0,1-12.17-8.6L25,75.45c-1.68-4.73,1.05-8.6,6.07-8.6H44.75a13.87,13.87,0,0,1,12.17,8.6Z' fill%3D'white'/%3E%3Cpath d%3D'M58.44 149.46c-1.68 4.73 1.06 8.6 6.07 8.6h13.68a13.86 13.86 0 0 0 12.17-8.6l26.27-74c1.68-4.73-1.06-8.6-6.07-8.6H96.88a13.86 13.86 0 0 0-12.17 8.6zm65.37 0c-1.68 4.73 1 8.6 6.07 8.6h13.68a13.88 13.88 0 0 0 12.17-8.6l26.26-74c1.68-4.73-1.05-8.6-6.07-8.6h-13.68a13.87 13.87 0 0 0-12.17 8.6z' fill%3D'%23e1e1e1'/%3E%3Cpath d%3D'M150.07,149.46c1.68,4.73-1,8.6-6.07,8.6H130.32a13.87,13.87,0,0,1-12.17-8.6l-26.27-74c-1.67-4.73,1.06-8.6,6.08-8.6h13.68a13.88,13.88,0,0,1,12.17,8.6Z' fill%3D'white'/%3E%3C/svg%3E");
  //      url('data:image/png;base64,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');
      background-size: contain;
    }
    &::after {
      content: 'spectrum';
      position: absolute;
      top: 58%;
      left: 50%;
      transform: translate3d(-50%, 0.5rem, 0);
      font-size: 0.7rem;
      color: $brn;
      font-weight: 400;
    }
    &.engage {
      &::after {
        content: 'engage'
      }
    }
  }
  & > .title {
    // center title
    @include large {
      background-color: transparent;
      font-size: 2rem;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      color: $brn;
      flex-grow: 1;
      transform: translate3d(0, 0.5rem, 0);
    }
    @include small {
      right: auto;
      left: 4rem;
      transform: translate3d(0, 0, 0);
    }
    color: white;
    font-size: 1.1rem;
    padding: 0.125rem 0.5rem;
    border-radius: 0 0 0.25rem 0.25rem;
    background-color: rgba($brn, 0.5);
    & > label {
      & > input {
        width: 100%;
        font-family: inherit;
        padding: 0;
        border: none;
        border-bottom: 1px solid orange;
        font-size: 2rem;
        color: $brn;
        text-align: left;
        font-weight: 300;
        &:focus {
          outline: none;
        }
        &::placeholder {
          color: inherit;
          text-align: inherit;
          font-weight: inherit;
        }
      }
    }
    .not-edit {
      user-select: none;
      text-align: left;
      width: 100%;
      border-bottom: 1px solid transparent;
      overflow: hidden;
      text-overflow: ellipsis;
      & > .favorite {
        &.hide {
          pointer-events: none;
          path {
            opacity: 0;
          }
        }
        & > svg {
          cursor: pointer;
          margin-left: 0.25rem;
          width: 24px;
          height: 24px;
          &.on,
          &:hover {
            path {
              fill: $brn;
            }
          }
          path {
            transition: all 250ms ease-in-out;
            fill: rgba($brn, 0.125);
          }
          //transform: scale(0.5);
        }
      }
    }
  }
  .engage-links {
    cursor: pointer;
    position: absolute;
    top: 50%;
    right: 12.25rem;
    transform: translate3d(0, -50%, 0);
    text-transform: uppercase;
    color: $brn;
    font-size: 0.9rem;
    font-family: 'Assistant', sans-serif;
    box-sizing: border-box;
    border: 1px solid transparent;
    border-radius: 0.25rem;
    padding: 0.125rem 1.75rem 0.125rem 0.5rem;
    background: white no-repeat calc(100% - 0.45rem) center;
    background-image: url('/link.svg');
    background-size: 1rem;
    opacity: 0.5;
    transition: all 250ms ease-in-out;
    &.on {
      opacity: 1;
      background-color: $brn;
      color: white;
      border-color: $brn;
      span {
        opacity: 1;
      }
    }
    &:hover {
      opacity: 1;
      z-index: 5;
      border-color: $brn;
      & > span {
        opacity: 1;
      }
    }
    & > span {
      transition: opacity 250ms ease-in-out;
      opacity: 0;
    }
  }
  .notifications-section {
    cursor: pointer;
    position: absolute;
    top: 50%;
    right: 17.5rem;
    transform: translate3d(0, -50%, 0);
    z-index: 6;
    display: grid;
    grid-template-columns: auto 1fr;
    grid-column-gap: 0.25rem;
    text-transform: uppercase;
    font-size: 0.8rem;
    font-family: 'Assistant', sans-serif;
    font-weight: 500;
    box-sizing: border-box;
    padding: 0.06125rem 0.5rem 0.06125rem 0.06125rem;
    border-radius: 0.25rem;
    color: white;
    border: 1px solid transparent;
    background-color: rgba($brn, 0.5);
    perspective: 50rem;
    &.hot {
      border: 1px solid orange;
      box-shadow: 0 0 4px #282828;
      background-color: orange;
      & > .count {
        color: $brn;
        box-shadow: 0 0 3px #282828 inset;
      }
    }
    &.very {
      animation: shadow-animation 900ms infinite;
      @keyframes shadow-animation {
        0% {
          transform: translate3d(0, -50%, 0);
          //box-shadow: 0 0 4px #282828;
        }
        20% {
          transform: translate3d(0, -50%, 0) rotate(-2deg);
          //box-shadow: 0 0 6px #282828;
          //top: 49%;
        }
        50% {
          transform: translate3d(0, -50%, 0) scale(1.05);
          //box-shadow: 0 0 6px #282828;
          //top: 49%;
        }
        90% {
          transform: translate3d(0, -50%, 0) rotate(2deg);
          //box-shadow: 0 0 6px #282828;
          //top: 49%;
        }
        100% {
          transform: translate3d(0, -50%, 0);
          //box-shadow: 0 0 4px #282828;
        }
      }
    }
    &.open {
      animation: none !important;
      & > .notifications-wrap {
        //transform: translate3d(0, 2rem, 0);
        //todo: needed only in safari
        //transform: translate3d(0, 0, 1px);
        transform: none;
        opacity: 1;
        pointer-events: all;
      }
    }
    & > .notifications-wrap {
      position: absolute;
      right: -5.25rem;
      top: 100%;
      margin-top: 0.85rem;
      background-color: white;
      box-sizing: border-box;
      padding: 2.5rem 1rem 1rem;
      border-radius: 0 0 0.25rem 0.25rem;
      border: 1px solid $brn;
      border-color: transparent;
      border-top-color: white;
      font-family: 'Assistant', sans-serif;
      color: $brn;
      transform-origin: top center;
      transform: rotateX(-93.5deg);
      transform-style: preserve-3d;
      transition: all 400ms ease-in-out;
      z-index: 19000;
      //opacity: 0;
      pointer-events: none;
      width: 42rem;
      min-height: 17rem;
      //max-height: 80vh;
      max-height: 37.6rem;
      backface-visibility: hidden;
      opacity: 0;
      box-shadow: 0 3px 3px #777;
      //transition: all 700ms cubic-bezier(0.175, 0.885, 0.32, 1.275);
      & > .close {
        cursor: pointer;
        position: absolute;
        top: -0.25rem;
        right: 0.4rem;
        font-size: 1.5rem;
        opacity: 0.25;
        color: black;
        transition: opacity 250ms ease-in-out;
        &:hover {
          opacity: 1;
        }
      }
      .items {
        display: grid;
        grid-template-columns: 1fr 21rem;
        grid-column-gap: 0.5rem;
        max-height: 35rem;
        cursor: default;
        .videos {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          grid-gap: 0.5rem;
          overflow: hidden;
          overflow-y: auto;
          max-height: 35rem;
          border-bottom-left-radius: 0.25rem;
          &.hide {
            opacity: 0;
          }
          &::-webkit-scrollbar {
            display: none;
          }
          .video {
            cursor: pointer;
            position: relative;
            background-color: rgba($brn, 0.25);
            height: 8rem;
            //max-width: 18rem;
            border-radius: 0.25rem;
            & > .details {
              position: absolute;
              left: 0.25rem;
              bottom: 0.25rem;
              right: 0.25rem;
              height: 2.5rem;
              background-color: rgba($brn, 0.7);
              box-sizing: border-box;
              padding: 0.125rem 0.25rem 0;
              border-radius: 0 0 0.25rem 0.25rem;
              color: white;
              font-weight: 500;
              //display: flex;
              //justify-content: space-between;
              white-space: nowrap;
              & > .title {
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              & > .age {
                text-align: right;
              }
            }
            & > .bg {
              position: absolute;
              top: 0.25rem;
              left: 0.25rem;
              bottom: 2.75rem;
              right: 0.25rem;
              background: white no-repeat center;
              background-size: cover;
              border-radius: 0.25rem 0.25rem 0 0;
            }
            & > .type.NOTfor-video {
              position: absolute;
              top: 0.125rem;
              right: 0.25rem;
              width: 1.8rem;
              height: 1.5rem;
              border-bottom-left-radius: 0.25rem;
              transform: scale(1.5);
              background: white no-repeat top right url("data:image/svg+xml;charset%3Dutf8,%3Csvg version%3D'1.1' xmlns%3D'http://www.w3.org/2000/svg' xmlns:xlink%3D'http://www.w3.org/1999/xlink' x%3D'0px' y%3D'0px' viewbox%3D'0 0 512 512' xml:space%3D'preserve' preserveaspectratio%3D'xMinYMin meet' width%3D'100%' height%3D'100%' style%3D'fill: %238D6E4F;'%3E%3Cpath transform%3D'scale(0.04)' d%3D'M265,96c65.3,0,118.7,1.1,168.1,3.3l0.7,0h0.7c23.1,0,42,22,42,49.1v1.1l0.1,1.1c2.3,34,3.4,69.3,3.4,104.9v0v0 c0.1,35.6-1.1,70.9-3.4,104.9l-0.1,1.1v1.1c0,13.8-4.7,26.6-13.4,36.1c-7.8,8.6-18,13.4-28.6,13.4h-0.8l-0.8,0c-52.9,2.5-108.8,3.8-166.4,3.8c-3.5,0-7.1,0-10.6,0H256h-0.1c-3.6,0-7.2,0-10.8,0c-57.8,0-113.7-1.3-166.2-3.7l-0.8,0h-0.8 c-10.6,0-20.7-4.8-28.5-13.4c-8.6-9.5-13.4-22.3-13.4-36.1v-1.1l-0.1-1.1c-2.4-34.1-3.5-69.4-3.3-104.7v-0.1v-0.1 c-0.1-35.3,1-70.5,3.3-104.6l0.1-1.1v-1.1c0-27.2,18.8-49.3,41.9-49.3H78l0.7,0c49.5-2.3,102.9-3.3,168.2-3.3h9H265 M265,64 c-3,0-6,0-9,0s-6,0-9,0c-57.6,0-114.2,0.8-169.6,3.3c-40.8,0-73.9,36.3-73.9,81.3C1,184.4-0.1,220,0,255.7c-0.1,35.7,0.9,71.3,3.4,107c0,45,33.1,81.6,73.9,81.6c54.8,2.6,110.7,3.8,167.8,3.8c3.6,0,7.3,0,10.9,0c3.6,0,7.2,0,10.7,0c57.1,0,113-1.2,167.9-3.8c40.9,0,74-36.6,74-81.6c2.4-35.7,3.5-71.4,3.4-107.1c0.1-35.7-1-71.3-3.4-107.1c0-45-33.1-81.1-74-81.1 C379.2,64.8,322.7,64,265,64L265,64z'%3E%3C/path%3E%3C/svg%3E");
              background-position-x: 0.4rem;
              background-size: contain;
              //opacity: 0.3;
              //&.on {
              //  opacity: 1;
              //}
              &::after {
                content: '';
                position: absolute;
                top: 0.425rem;
                left: 0.8rem;
                height: 0;
                width: 0;
                border: 0.2rem solid transparent;
                border-left-width: 0.4rem;
                border-left-color: $brn;
              }
            }
          }
        }
        .documents {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          grid-gap: 0.5rem;
          max-height: 35rem;
          overflow: hidden;
          overflow-y: auto;
          border-bottom-right-radius: 0.25rem;
          &.hide {
            opacity: 0;
          }
          &::-webkit-scrollbar {
            display: none;
          }
          .document {
            cursor: pointer;
            position: relative;
            background-color: rgba($brn, 0.25);
            height: 10.25rem;
            width: 6.5rem;
            border-radius: 0.25rem;
            //border: 1px solid rgba($brn, 0.25);
            & > .details {
              position: absolute;
              left: 0.25rem;
              bottom: 0.25rem;
              right: 0.25rem;
              height: 1.25rem;
              background-color: rgba($brn, 0.7);
              box-sizing: border-box;
              padding: 0.125rem 0.25rem 0;
              border-radius: 0 0 0.25rem 0.25rem;
              color: white;
              font-weight: 500;
              //display: flex;
              //justify-content: space-between;
              white-space: nowrap;
              & > .title {
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              & > .age {
                text-align: right;
              }
            }
            & > .bg {
              position: absolute;
              top: 0.25rem;
              left: 0.25rem;
              bottom: 1.25rem;
              right: 0.25rem;
              background: white no-repeat center;
              background-size: cover;
              border-radius: 0.25rem 0.25rem 0 0;
            }
            & > .type.NOTfor-document {
              position: absolute;
              top: 0.125rem;
              right: 0.25rem;
              width: 1.8rem;
              height: 1.5rem;
              border-bottom-left-radius: 0.25rem;
              transform: scale(1.5);
              background: white no-repeat top right
                url("data:image/svg+xml;charset%3Dutf8,%3C?xml version%3D'1.0' encoding%3D'UTF-8'?%3E%3Csvg xmlns%3D'http://www.w3.org/2000/svg' width%3D'100' height%3D'100'%3E%3Cstyle%3Epath { stroke: %238d6e4f; fill: %238d6e4f; stroke-width: 0.015 }%3C/style%3E%3Cpath d%3D'M83.012,17.5c0-0.527-0.271-0.99-0.682-1.258L66.477,2.637c-0.15-0.129-0.324-0.211-0.505-0.271C65.709,2.141,65.373,2,65,2 H18.5C17.671,2,17,2.671,17,3.5v93c0,0.828,0.671,1.5,1.5,1.5h63c0.828,0,1.5-0.672,1.5-1.5V18c0-0.067-0.011-0.13-0.02-0.195 C83.001,17.707,83.012,17.604,83.012,17.5z M20,95V5h44v12.5c0,0.829,0.672,1.5,1.5,1.5H80v76H20z'/%3E%3Cpath d%3D'M69,31H31c-0.552,0-1-0.448-1-1s0.448-1,1-1h38c0.553,0,1,0.448,1,1S69.553,31,69,31z'/%3E%3Cpath d%3D'M69,45H31c-0.552,0-1-0.448-1-1s0.448-1,1-1h38c0.553,0,1,0.448,1,1S69.553,45,69,45z'/%3E%3Cpath d%3D'M69,57H31c-0.552,0-1-0.447-1-1s0.448-1,1-1h38c0.553,0,1,0.447,1,1S69.553,57,69,57z'/%3E%3Cpath d%3D'M69,71H31c-0.552,0-1-0.447-1-1s0.448-1,1-1h38c0.553,0,1,0.447,1,1S69.553,71,69,71z'/%3E%3C/svg%3E");
              background-size: 48%;
              //top: 0.125rem;
              //left: 0.4rem;

              //background-position-x: 0.4rem;
              //background-size: contain;
              //opacity: 0.3;
              //&.on {
              //  opacity: 1;
              //}
            }
          }
        }
      }
    }
    & > .count {
      background-color: white;
      font-size: 2rem;
      font-weight: 600;
      line-height: 1.8rem;
      box-sizing: border-box;
      color: rgba($brn, 0.7);
      padding: 0.25rem 0.5rem;
      border-top-left-radius: 0.25rem;
      border-bottom-left-radius: 0.25rem;
    }
    & > .label {
      padding-top: 0.55rem;
    }
  }
  .mini-profile {
    cursor: pointer;
    position: absolute;
    top: 0.55rem;
    right: 27.5rem;
    width: 2rem;
    height: 3rem;
    //transform: translate3d(0, -50%, 0);
    text-transform: uppercase;
    color: $brn;
    font-size: 0.9rem;
    font-family: 'Assistant', sans-serif;
    box-sizing: border-box;
    //border: 1px solid $brn;
    border-radius: 0.25rem;
    //padding: 0.125rem 1.75rem 0.125rem 0.5rem;
    //background-color: white;
    //background-image: url('/link.svg');
    //background-size: 1rem;
    //opacity: 0.5;
    transition: all 250ms ease-in-out;
    z-index: 9;
    &:hover {
      & > .title {
        opacity: 1;
      }
    }
    & > .title {
      pointer-events: none;
      position: absolute;
      top: 50%;
      right: 100%;
      box-sizing: border-box;
      padding: 0.5rem 0.25rem 0.75rem 3rem;
      margin-top: 0.125rem;
      transform: translate3d(-0.3rem, -50%, 0);
      white-space: nowrap;
      transition: opacity 250ms ease-in-out;
      background-color: white;
      opacity: 0;
      &.hide {
        opacity: 0 !important;
      }
    }
    &.known {
      & > svg {
        & > g {
          fill: $brn;
        }
      }
    }
    & > svg {
      transform: scale(0.15);
      transform-origin: top left;
      & > g {
        fill: rgba($brn, 0.5);
      }
    }
  }
  .spotlight-source {
    cursor: pointer;
    position: absolute;
    top: 0.75rem;
    right: 35rem;
    background: no-repeat center;
    background-size: contain;
    width: 3rem;
    height: 3rem;
    opacity: 0.5;
    transition: opacity 250ms ease-in-out;
    &.on {
      opacity: 1;
    }
  }
  .launch-tour {
    cursor: pointer;
    position: absolute;
    top: 1.25rem;
    right: 31rem;
    //transform: translate3d(0, -50%, 0);
    text-transform: uppercase;
    color: $brn;
    font-size: 0.9rem;
    font-family: 'Assistant', sans-serif;
    box-sizing: border-box;
    border: 1px solid rgba($brn, 0.5);
    border-radius: 0.25rem;
    padding: 0.25rem 0.5rem;
    background-color: white;
    text-align: center;
    transition: all 250ms ease-in-out;
    &:hover {
      color: black;
      border-color: black;
    }

  }
  .profile {
    cursor: pointer;
    position: absolute;
    top: 0.3rem;
    right: 25.45rem;
    width: 18rem;
    height: 18rem;
    //transform: translate3d(0, -50%, 0);
    text-transform: uppercase;
    color: $brn;
    font-size: 0.9rem;
    font-family: 'Assistant', sans-serif;
    box-sizing: border-box;
    border: 1px solid $brn;
    border-radius: 0.25rem;
    //padding: 0.125rem 1.75rem 0.125rem 0.5rem;
    background-color: white;
    //background-image: url('/link.svg');
    //background-size: 1rem;
    //opacity: 0.5;
    transition: all 250ms ease-in-out;
    display: flex;
    padding-top: 3.25rem;
    opacity: 0;
    pointer-events: none;
    z-index: 8;
    &.shown {
      opacity: 1;
      pointer-events: all;
    }
    & > .title {
      position: absolute;
      top: 1.5rem;
      left: 0.5rem;
      right: 2.5rem;
      text-align: center;
      font-size: 1.5rem;
      animation: hide-animation 900ms infinite;
      @keyframes hide-animation {
        0% {
          opacity: 0.95;
        }
        50% {
          opacity: 0.95;
        }
        55% {
          //opacity: 0.85;
        }
        90% {
          opacity: 1;
        }
        100% {
          opacity: 1;
        }
      }
    }
    & > .code {
      transition: transform 250ms ease-in-out;
      &.hide {
        transform: rotate3d(1, 1, 0, 90deg);
      }
    }
    & > .log-out {
      cursor: pointer;
      position: absolute;
      bottom: 0.5rem;
      left: 0.5rem;
      right: 1.5rem;
      text-align: center;
      font-size: 0.8rem;
      text-transform: uppercase;
      font-family: 'Assistant', sans-serif;
      color: $brn;
      opacity: 0.5;
      transition: opacity 250ms ease-in-out;
      &.hide {
        opacity: 0 !important;
        pointer-events: none;
      }
      &:hover {
        opacity: 1;
      }
    }
    & > .auth-status {
      position: absolute;
      top: 4.25rem;
      right: 1rem;
      display: grid;
      grid-template-rows: repeat(5, 2rem);
      grid-row-gap: 0.25rem;
      transition: opacity 700ms ease-in-out 4s;
      &.complete {
        opacity: 0;
        pointer-events: none;
        & > .box {
          background-color: orange !important;
          border-color: orange;
        }
        & > .auth {
          &::after {
            content: 'ready' !important;
          }
        }
      }
      &.initial {
        & > .auth {
          &::after {
            content: 'scan' !important;
          }
        }
      }
      & > .box {
        position: relative;
        width: 2rem;
        background-color: rgba($brn, 0.125);
        box-sizing: border-box;
        border: 1px solid rgba($brn, 0.5);
        border-radius: 0.125rem;
        transition: background-color 400ms ease-in-out;
        &.on,
        &.shown {
          background-color: rgba($brn, 0.7);
        }
        &.auth {
          &::after {
            content: '';
            position: absolute;
            top: 100%;
            left: 50%;
            font-size: 0.75rem;
            transform: translate3d(-50%, 0.7rem, 0);
          }
        }
      }
    }
    &.shown + .mask {
      opacity: 1;
    }
    & + .mask {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      height: 100vh;
      background-color: rgba($brn, 0.85);
      opacity: 0;
      pointer-events: none;
      transition: opacity 400ms ease-in-out;
      z-index: 7;
    }
  }
  .engage-bap {
    position: absolute;
    top: 0.25rem;
    right: 0.5rem;
    border: 1px solid rgba($brn, 0.5);
    border-radius: 0.25rem;
    padding: 0.25rem 0.75rem;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    background-color: white;
    transform: scale(1.5);
    transform-origin: top right;
    .play-button {
      cursor: pointer;
      background: no-repeat top left
        url("data:image/svg+xml;charset%3Dutf8,%3Csvg version%3D'1.1' xmlns%3D'http://www.w3.org/2000/svg' xmlns:xlink%3D'http://www.w3.org/1999/xlink' x%3D'0px' y%3D'0px' viewbox%3D'0 0 512 512' xml:space%3D'preserve' preserveaspectratio%3D'xMinYMin meet' width%3D'100%' height%3D'100%' style%3D'fill: %238D6E4F;'%3E%3Cpath transform%3D'scale(0.09)' d%3D'M265,96c65.3,0,118.7,1.1,168.1,3.3l0.7,0h0.7c23.1,0,42,22,42,49.1v1.1l0.1,1.1c2.3,34,3.4,69.3,3.4,104.9v0v0 c0.1,35.6-1.1,70.9-3.4,104.9l-0.1,1.1v1.1c0,13.8-4.7,26.6-13.4,36.1c-7.8,8.6-18,13.4-28.6,13.4h-0.8l-0.8,0c-52.9,2.5-108.8,3.8-166.4,3.8c-3.5,0-7.1,0-10.6,0H256h-0.1c-3.6,0-7.2,0-10.8,0c-57.8,0-113.7-1.3-166.2-3.7l-0.8,0h-0.8 c-10.6,0-20.7-4.8-28.5-13.4c-8.6-9.5-13.4-22.3-13.4-36.1v-1.1l-0.1-1.1c-2.4-34.1-3.5-69.4-3.3-104.7v-0.1v-0.1 c-0.1-35.3,1-70.5,3.3-104.6l0.1-1.1v-1.1c0-27.2,18.8-49.3,41.9-49.3H78l0.7,0c49.5-2.3,102.9-3.3,168.2-3.3h9H265 M265,64 c-3,0-6,0-9,0s-6,0-9,0c-57.6,0-114.2,0.8-169.6,3.3c-40.8,0-73.9,36.3-73.9,81.3C1,184.4-0.1,220,0,255.7c-0.1,35.7,0.9,71.3,3.4,107c0,45,33.1,81.6,73.9,81.6c54.8,2.6,110.7,3.8,167.8,3.8c3.6,0,7.3,0,10.9,0c3.6,0,7.2,0,10.7,0c57.1,0,113-1.2,167.9-3.8c40.9,0,74-36.6,74-81.6c2.4-35.7,3.5-71.4,3.4-107.1c0.1-35.7-1-71.3-3.4-107.1c0-45-33.1-81.1-74-81.1 C379.2,64.8,322.7,64,265,64L265,64z'%3E%3C/path%3E%3C/svg%3E");
      background-size: contain;
      position: relative;
      overflow: hidden;
      .play-pause {
        position: absolute;
        top: 0;
        left: 0;
        background: transparent;
        box-sizing: border-box;
        width: 0;
        height: 74px;
        border-color: transparent transparent transparent $brn;
        transition: 100ms all ease;
        transform: scale(0.25) translate3d(-1.5rem, -3.5rem, 0);
        // play state
        border-style: solid;
        border-width: 37px 0 37px 60px;
        &.paused {
          border-style: double;
          border-width: 0 0 0 60px;
        }
        &:hover {
          border-color: transparent transparent transparent #404040;
        }
      }
    }
  .report-card-opener {
    cursor: pointer;
    position: absolute;
    right: 0.3rem;
    bottom: 0.25rem;
    font-size: 0.5rem;
    text-transform: uppercase;
    & + .pub-logo {
      transform: scale(0.7) translate3d(0.5rem, 0, 0);
      transform-origin: top center;
    }
  }
  .pub-logo {
      width: 3rem;
      height: 3rem;
      background: no-repeat center;
      background-size: contain;
    }
  }
  .lp {
    position: absolute;
    top: 1rem;
    right: 2rem;
    font-size: 2rem;
    color: $brn;
    width: 9.375rem;
  }
  .reading-list {
    position: fixed;
    right: 1rem;
    top: 1rem;
    background-color: white;
    box-shadow: 1px 1px 3px black;
    padding: 1rem;
    .items {
      display: grid;
      grid-template-columns: repeat(5, 20%);
      .item {
        width: 6rem;
        padding-top: 100%;
        margin: 0.25rem;
        background: no-repeat center;
        background-size: contain;
        background-color: white;
        outline: 2px solid #dadada;
        //box-shadow: 1px 1px 3px black;
        cursor: pointer;
        //outline: 1px solid black;
        &.selected {
          outline: 2px solid orange;
          box-shadow: 1px 1px 5px black;
          /*box-shadow: 1px 1px 3px black,
                      1px 1px 6px black,
                      1px 1px 9px black;*/
        }
      }
    }
  }
  .settings {
    display: none;
    @include large {
      display: block;
      cursor: pointer;
      /*position: absolute;*/
      /*right: 0.7rem;*/
      margin-top: -0.25rem;
      /*margin-right: 0.5rem;*/
      width: 2rem;
      height: 2rem;
      background: no-repeat center
        url("data:image/svg+xml;charset%3Dutf8,%3Csvg xmlns%3D'http://www.w3.org/2000/svg' width%3D'48' height%3D'48'%3E%3Cg transform%3D'matrix(3.3932944,0,0,3.3932521,-2.8994163,-2.8988019)'%3E%3Cpath transform%3D'matrix(1.150996,-0.252943,0.253334,1.109085,-1.33593,2.243337)' d%3D'M 9.1597054,10.535626 C 8.5353139,10.932967 7.9870803,9.7868435 7.2581623,9.9149935 C 6.5292443,10.043144 6.404799,11.307529 5.6823257,11.14698 C 4.9598523,10.98643 5.3826241,9.7883391 4.7765854,9.363532 C 4.1705467,8.9387249 3.1884949,9.7447846 2.7911548,9.1203931 C 2.3938147,8.4960015 3.5399378,7.947768 3.4117877,7.2188499 C 3.2836377,6.4899319 2.0192519,6.3654866 2.1798015,5.6430133 C 2.3403511,4.9205399 3.5384422,5.3433117 3.9632493,4.737273 C 4.3880564,4.1312344 3.5819967,3.1491825 4.2063882,2.7518424 C 4.8307798,2.3545024 5.3790133,3.5006254 6.1079314,3.3724754 C 6.8368494,3.2443253 6.9612946,1.9799395 7.683768,2.1404891 C 8.4062413,2.3010388 7.9834696,3.4991298 8.5895083,3.9239369 C 9.1955469,4.348744 10.177599,3.5426843 10.574939,4.1670759 C 10.972279,4.7914674 9.8261558,5.3397009 9.9543059,6.068619 C 10.082456,6.797537 11.346842,6.9219823 11.186292,7.6444556 C 11.025743,8.366929 9.8276515,7.9441572 9.4028444,8.5501959 C 8.9780373,9.1562345 9.7840969,10.138286 9.1597054,10.535626 z' style%3D'fill:white;fill-opacity:0;stroke-width:0.3;stroke:#8d6e4f;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1' /%3E%3Cpath transform%3D'matrix(1.349611,0,0,1.189061,-2.731052,-1.723202)' d%3D'M 8.8845207,8.1769037 A 0.90417689,1.022113 0 1 1 7.0761669,8.1769037 A 0.90417689,1.022113 0 1 1 8.8845207,8.1769037 z' style%3D'fill:blue;fill-opacity:0;stroke:#8d6e4f;stroke-width:0.3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1'/%3E%3C/g%3E%3C/svg%3E");
      background-size: cover;
    }
  }
}
</style>
<style lang="scss">
.settings-button-tab {
  .tab-content {
    max-width: 25rem;
  }
}
</style>
